import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import {
  SiteConfigActionTypes,
  ActionSetPageTitle
} from './types';
import { SiteConfig } from '../../models/SiteConfig';

export const dispatchSetPageTitle = (payload: SiteConfig): ActionSetPageTitle => {
  return {
    type: SiteConfigActionTypes.ACTION_SET_PAGE_TITLE,
    payload,
  };
};

// Action Creators
export const actionSetPageTitle = (payload: SiteConfig) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchSetPageTitle(payload));
  };
};
